<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>

    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button>
        <Button @click="openAdd()" type="primary" class="chaxun">新增</Button>

      </template></selectTool>
    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"><template slot-scope="{ row, index }" slot="liucheng">
        <Button v-if="row.flowStartId == null" size="small" @click="addFlow(row)">重新发起</Button>
        <span v-else>已发起</span>
      </template>
      <template slot-scope="{ row, index }" slot="passengers">
        <ul>
          <li v-for="(x, index) in row.passengers" :key="index">
            {{ x.name }}/{{ x.tel }}
          </li>
        </ul>
      </template>
      <template slot-scope="{ row, index }" slot="action">

        <Button size="small" @click="openJincheng(row)">审批进程</Button>
      </template>
      <template slot-scope="{ row, index }" slot="sjjincheng">

        <Button size="small" @click="sijigenjin(row)">司机跟进</Button>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button size="small" @click="copy(row)" type="primary">复制</Button>
        <Button size="small" @click="openUpdate(row)">编辑</Button>
        <Button size="small" v-if="row.optStatus != 6" @click="cheHui(row)">作废</Button>
        <Button size="small" v-if="false" @click="exportAll(row)" class="chaxun">导出</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增用车申请' : '编辑用车申请'" width="1000" ref="formModel">

      <tableForm slot="passengers" ref="passengers" :forms="passengersForm" :item1="passengersItem"
        v-model="item.passengers">
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <createdFlow ref="createdFlow" @ok="getList"></createdFlow>
    <jincheng ref="jincheng"></jincheng>
    <sjjincheng ref="sjjincheng"></sjjincheng>
  </div>
</template>
<script>
import fields from "./forms/fields";
import createdFlow from "./forms/createdFlow.vue";
import jincheng from "./jincheng.vue";
import alotItem from "./alotItem.vue";
import sjjincheng from "./jincheng/jincheng.vue"
export default {
  components: { createdFlow, sjjincheng, jincheng, alotItem },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "工单号",
          key: "no",
          align: "center",
          minWidth: 130,
          sort: 0.2,
        },
        {
          title: "车牌号",
          key: "carNo",
          sort: 47,
        },
        {
          title: "驾驶员",
          key: "driverName",
          sort: 48,
        },
        {
          title: "驾驶员电话",
          key: "tel",
          sort: 48,
        },
        {
          title: "创建时间",
          key: "createTime",
          minWidth: 120,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 50,
        },
        {
          title: "流程状态",
          slot: "liucheng",
          maxWidth: 300,
          minWidth: 100,
          sort: 1.1,
        },
        {
          title: "司机跟进",
          slot: "sjjincheng",
          maxWidth: 300,
          minWidth: 100,
          sort: 1.1,
        },
        {
          title: "流程操作",
          slot: "action",
          width: 150,
          align: "center",
          sort: 1.2,
        },
        {
          title: "操作",
          slot: "action1",
          width: 150,
          align: "center",
          fixed: "right",
          sort: 51,
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        planStartAdd: "",
        planStartTime: Date.now(),
        tel: "",
        user: "user",
        passengers: [],
        cs: 2,
        des: "拜访客户",
        number: 1,
        planEndAdd: "",
        planEndTime: Date.now() + 86400000 * 2,
        planEndX: 0,
        planEndY: 0,
        planReachAdd: "",
        planReachTime: Date.now() + 86400000,
        planReachX: 0,
        planReachY: 0,
        planStartX: 0,
        planStartY: 0,
        remark: "",
        type: "",
        weight: 0,
        id: ''
      },
      searchItem: {
        driverAccountId: [],
        groupIdList: [],
        carIdList: [],
        endTime: 0,
        startTime: 0,
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        taskStatus: 0, //0-全部，1-待办，2-进行，3-完成
        optStatus: 0//6--作废 0--正常
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "订单号",
          key: "no",
          type: "Input",
        },
        {
          title: "选择单位",
          groupIds: "groupIdList",
          clearable: true,
          more: true,
          type: "selectGroup",
        },
        {
          title: "车牌号",
          carIdList: "carIdList",
          type: "selectAlotCar",
        },
        {
          title: "驾驶员",
          accountIds: "driverAccountId",
          //key4: "ffff",
          type: "selectUser",
          keyword: '司机',
          more: true
        }, 
 

      ],
      total: 0,
      categorys: [],
      forms: fields["yongcheshenqing"],
      flowList: [],
      passengersForm: [
        {
          title: '姓名',
          key: 'name',
          type: 'Input',
        },
        {
          title: '电话',
          key: 'tel',
          type: 'Input',
        }
      ],
      passengersItem: {
        name: '',
        tel: '',
        remark: ''
      }

    };
  },
  methods: {
    getList() {
      this.ssear();
      //console.log(33333, this.searchItem);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpc + "/apply/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].planStartTime2 = this.utils.time(
            data[i].planStartTime,
            "yymmddhhmm"
          );
          data[i].planEndTime2 = this.utils.time(
            data[i].planEndTime,
            "yymmddhhmm"
          );
          data[i].planReachTime2 = this.utils.time(
            data[i].planReachTime,
            "yymmddhhmm"
          );
        }
        this.tableData = data;
        console.log(data);
      });
    },
    ssear() {
      if (!this.utils.isEmpty(this.searchItem.groupId)) {
        this.searchItem.groupIdList = [this.searchItem.groupId];
      }


    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      console.log(this.item.passengers);
      this.item.number = this.item.passengers.length;
      if (this.isAdd) {
        this.item.tel='';
        this.axios({
          method: "post",
          url: this.axios.dpc + "/apply/apply",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
            var data = res.data.data;
            /* var obj = {
              no: data.no,
              id: data.id, //文档id
              groupId: data.groupId,
              flowId: this.flowId,
              formId: 11, //模板id
            };
            this.$refs.createdFlow.reach(obj); */
            this.addFlow(data);
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.dpc + "/apply/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(data) {
      var obj = {
        no: data.no,
        id: data.id, //文档id
        groupId: data.groupId,
        flowId: this.flowId,
        formId: 11, //模板id
      };
      this.$refs.createdFlow.reach(obj);
    },
    //订单撤回
    cheHui(data) {
      this.$Modal.confirm({
        title: "是否作废？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-ofc-server-web/dpcApply/cancelApply",
            data: {
              "no": data.no
            },
          }).then((res) => {
            console.log(res);
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    sijigenjin(x) {
      var obj = {
        ono: x.no,
        flowId: x.dispatchFlowId
      }
      this.$refs.sjjincheng.open(obj);
    },
    //点击编辑按钮
    openUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i]
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },
    copy(row) {
      this.isAdd = true;

      for (const i in this.item) {
        this.item[i] = row[i]
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },

    openAdd(x) {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    addFlow(data) {
      console.log(data);
      var obj = {
        flowId: this.flowId,
        id: data.id,
        no: data.no,
        groupId: data.groupId,
        formId: 'yongcheshenqing', //模板id,
        filler: '/apply'
      };
      this.$refs.createdFlow.reach(obj);


    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    search() {
      this.getList();
    },
    exportAll(x) {
      var params = [
        {
          name: "no",
          value: x.no,
        },

      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-ofc-server-web/dpcApply/exportWord", params);
    },

    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
  },
  mounted() {
    //this.cols();
    //this.chaxun();
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/diaodu/shenqing.vue